import {__} from '@wordpress/i18n';

const fontSizes = [
    {
        name: __( 'Small', 'buba-blocks' ),
        slug: 'small',
        size: 12,
    },
    {
        name: __( 'Normal', 'buba-blocks' ),
        slug: 'normal',
        size: 16,
    },
    {
        name: __( 'Medium', 'buba-blocks' ),
        slug: 'medium',
        size: 20,
    },
    {
        name: __( 'Big', 'buba-blocks' ),
        slug: 'big',
        size: 26,
    },
    {
        name: __( 'Huge', 'buba-blocks' ),
        slug: 'huge',
        size: 40,
    },
]
export default fontSizes;